import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ApiModule, Configuration, ConfigurationParameters } from './api/exa';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AppInitService } from './services/app-init.service';
import { IonicStorageModule } from '@ionic/storage-angular';
import { StorageService } from './services/storage.service';

import { TranslateModule } from '@ngx-translate/core';

import { Geolocation } from '@capacitor/geolocation';
import { IconService } from './services/icon.service';
import { SharedComponentsModule } from './components/shared-components.module';

import { AlertService } from './services/alert.service';
import { CustomerContextMenuComponent } from './components/popover/customerContextMenu/customer-context-menu.component';
import { MachineContextMenuComponent } from './components/popover/machineContextMenu/machine-context-menu.component';
import { FieldContextMenuComponent } from './components/popover/fieldContextMenu/field-context-menu.component';
import { ImplementContextMenuComponent } from './components/popover/implementContextMenu/implement-context-menu.component';
import { LocationContextMenuComponent } from './components/popover/locationContextMenu/location-context-menu.component';
import { EmployeeContextMenuComponent } from './components/popover/employeeContextMenu/employee-context-menu.component';

import { BootstrapService } from './services/bootstrap.service';
import { GoogleMapsModule } from '@angular/google-maps';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

// export function apiConfigFactory(): Configuration {
//   const params: ConfigurationParameters = {
//     basePath: 'http://localhost:8080'
//     // set configuration parameters here.
//   };
//   return new Configuration(params);
// }
const apiConfigFactory = (): Configuration => {
  const params: ConfigurationParameters = {};
  // see app initialized
  return new Configuration(params);
};
const initializeApp = (appInitService: AppInitService) => () => appInitService.init();

@NgModule({
  declarations: [
    AppComponent,
    CustomerContextMenuComponent,
    MachineContextMenuComponent,
    EmployeeContextMenuComponent,
    FieldContextMenuComponent,
    ImplementContextMenuComponent,
    LocationContextMenuComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ApiModule.forRoot(apiConfigFactory),
    LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG }),
    IonicStorageModule.forRoot(),
    SharedComponentsModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    GoogleMapsModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AppInitService,
    IconService,
    AlertService,
    BootstrapService,
    AlertService,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService, IconService, StorageService], multi: true },
    provideAnimationsAsync(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
